<header
  class="dashboard-header d-flex align-items-center justify-content-between position-sticky top-0 z-3"
>

  <!-- LEFT: Hamburger (mobile) + Breadcrumb -->
  <div class="dashboard-header-left d-flex align-items-center">

    <!-- 🍔 MOBILE SIDEBAR TOGGLE -->
    <button
      v-if="is_mobile"
      class="btn btn-sm btn-outline-primary rounded-circle d-flex align-items-center justify-content-center"
      @click="$emit('toggle-mobile-sidebar')"
    >
      <i class="bi bi-list"></i>
    </button>

    <!-- Breadcrumb -->
    <div class="breadcrumb dashboard-breadcrumb d-flex align-items-center flex-wrap mb-0">

      <template v-if="breadcrumb && breadcrumb.length">
        <span
          v-for="(crumb, i) in breadcrumb"
          :key="crumb.id + '-' + i"
          class="d-flex align-items-center "
        >
          <a
            v-if="i < breadcrumb.length - 1"
            href="#"
            @click.prevent="$emit('breadcrumb-click', crumb.id)"
            class="text-white text-decoration-none "
          >
            {{ crumb.title }}
          </a>

          <span
            v-else
            class="text-white fw-semibold "
          >
            {{ crumb.title }}
          </span>

          <span v-if="i < breadcrumb.length - 1" class="text-white mx-1">/</span>
        </span>
      </template>

      <span v-else class="text-white fw-semibold ">
        Dashboard
      </span>

    </div>
  </div>

  <!-- RIGHT: Actions -->
  <ul class="dashboard-header-actions navbar-nav flex-row align-items-center">

    <!-- 🤖 NPI Assistant (DESKTOP ONLY) -->
    <li class="nav-item d-none d-md-block">
      <BolideAssistantButton @open-assistant="openAssistant" />
    </li>

    <!-- Logout -->
    <li class="nav-item">
      <a
        href="#"
        class="nav-link text-white p-0"
        @click.prevent="logoutUser"
      >
        <i class="bi bi-box-arrow-right fs-6"></i>
      </a>
    </li>

  </ul>

</header>
